import { jsx as _jsx } from "react/jsx-runtime";
import { FormFlex } from '../FormGrid';
import { Typography } from '../Typography';
export function FileBundleError({ bundleErrors }) {
    return (_jsx("div", { children: _jsx(FormFlex, { columnGap: 2, rowGap: 0, children: bundleErrors.map((error, index) => (_jsx(Typography, { variant: "body2", color: "error", children: error?.message }, index))) }) }));
}
